import { Component } from '@angular/core';
import { NgxPermissionsService } from "ngx-permissions";
import { Router } from "@angular/router";
@Component({
    selector: 'app-user-management',
    template: `<router-outlet></router-outlet>`,
    styleUrls: []
})
export class UserManagmentRouteComponent {
    constructor(
        private ngxPermissionService: NgxPermissionsService,
        private router: Router,
    ) {
        // let permissions = this.ngxPermissionService.getPermissions();
        // const permissionsList = Object.keys(permissions);
        // console.log(permissionsList);
        // if(!(permissionsList.includes('create-user') || permissionsList.includes('activate-deactivate-user'))) {
        //     this.router.navigateByUrl('/home/program-dashboard');
        // }
    }
}
